export enum NoticeType {
	INFO = 'Information Notification',
	SUCCESS = 'Success Notification',
	ERROR = 'Error Notification',
	WARNING = 'Warning Notification',
	NEUTRAL = 'Neutral Notification',
}
